import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { To } from 'react-router-dom';
import { readLastVariant, lobbyPathForVariant } from 'lib/variant-assets';

/** Sensible fallback when there is no in-app history to pop. */
export function useBackFallback(): To {
  const { pathname, search } = useLocation();

  return useMemo(() => {
    const lastVariant = readLastVariant();
    if (pathname.startsWith('/lobby')) return '/home';
    if (pathname.startsWith('/rules')) {
      const params = new URLSearchParams(search);
      return lobbyPathForVariant(params.get('variant') || lastVariant);
    }
    if (pathname.startsWith('/table/')) return lobbyPathForVariant(lastVariant);
    if (pathname.startsWith('/private/')) return `${lobbyPathForVariant(lastVariant)}&private=1`;
    return lobbyPathForVariant(lastVariant);
  }, [pathname, search]);
}

export function shouldShowAppBack(pathname: string): boolean {
  if (pathname === '/' || pathname === '/home' || pathname === '/session-expired') return false;
  if (pathname.startsWith('/table/')) return false;
  if (pathname.startsWith('/private/') && pathname !== '/private') return false;
  if (pathname === '/table-asset') return false;
  return true;
}
